/*eslint no-magic-numbers: 0*/
import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

import {
  getCircleColor,
  getColor,
  getFaceTransparency,
  getSmileySource,
} from "../../../../../../store/helpers/uiHelper";

import faceHigh from "../../../../../../assets/images/icons/face_high.svg";
import faceLow from "../../../../../../assets/images/icons/face_low.svg";
import faceMed from "../../../../../../assets/images/icons/face_med.svg";

//scss
import "../../../../scss/circle.scss";
import "./MoraleIndexScore.scss";

class MoraleIndexScore extends Component {
  render() {
    const { questionAverages, moraleComments, isTeam360 } = this.props;

    let firstParagraph = "";
    let secondParagraph = "";
    let paragraphs = [];

    if (isTeam360) {
      firstParagraph =
        "This page gives you a Morale indicator for your team and compares them to the views of your stakeholders. The overall morale indicator is shown with a summary face for both your team (on the left) and your stakeholders (on the right).";
      secondParagraph =
        "The stakeholder scores can give you a good opportunity to go back to your clients, suppliers or colleagues and ask why they scored as they did and how these scores can be improved. You may uncover simple processes or acts that have a really positive affect on the team and their external relationships.";
      paragraphs.push(firstParagraph);
      paragraphs.push(secondParagraph);
    } else {
      moraleComments && moraleComments.comments.map((comment) => paragraphs.push(comment));
    }
    return (
      <Fragment>
        <div className="morale-index__container">
          <div className="morale-index__container-box">
            {paragraphs.map((paragraph, index) => (
              <h6 className="mt-2" key={index}>
                {paragraph}
              </h6>
            ))}
          </div>
          {questionAverages && (
            <div className="morale-index-container__values-wrapper">
              <div className="morale-index__details-smiley">
                <img className="face" src={getSmileySource(questionAverages.mi)} alt="face" />
              </div>
              <div className="morale-index__details__info-container">
                <div className="morale-index__details__info-container-details-blue">
                  <span>TL</span>
                </div>
                <div className="morale-index__details__info-container-details">
                  <span
                    className="morale-index__details__info-container-details-index"
                    style={{
                      color: getColor(questionAverages.mi),
                    }}
                  >
                    mi
                  </span>
                </div>
              </div>
              <div className="morale-index__details-progress">
                <div
                  className={`c100 p${questionAverages.mi * 10} ${getCircleColor(
                    questionAverages.mi
                  )}`}
                >
                  <span>{questionAverages.mi}</span>
                  <div className="slice">
                    <div className="bar" />
                    <div className="fill" />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {questionAverages && (
          <div className="morale-index__content-faces">
            <img
              className={`${getFaceTransparency(questionAverages.mi, "low")}`}
              src={faceLow}
              alt="morale-low"
            />
            <img
              className={`${getFaceTransparency(questionAverages.mi, "med")}`}
              src={faceMed}
              alt="morale-med"
            />
            <img
              className={`${getFaceTransparency(questionAverages.mi, "high")}`}
              src={faceHigh}
              alt="morale-high"
            />
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  questionAverages: state.reports.questionAverages,
  moraleComments: state.reports.moraleComments,
  isTeam360: state.reports.reportStatus.is_team_360,
});

MoraleIndexScore.propTypes = {
  questionAverages: PropTypes.object,
  radius: PropTypes.number,
  stroke: PropTypes.number,
  strokeDashoffset: PropTypes.number,
  progress: PropTypes.number,
  moraleComments: PropTypes.object,
  isTeam360: PropTypes.bool,
};

export default connect(mapStateToProps, null)(MoraleIndexScore);
